import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsSystemRolesDeleteRoute: InvariantJiraRoute = {
	name: 'global-settings-system-roles-delete',
	path: '/secure/project/DeleteProjectRole([!%]?[\\w]*).jspa',
};
